module.exports = __webpack_public_path__ + "static/media/nyu_logo.bc0d6e70.png";